import { memo, useMemo } from "react";
import { useLocalization } from "@fluent/react";
import App from "byzantine/src/App";
import { translateOAuthApplication } from "byzantine/src/l10n/SettingLocalizers";
import AppAuthorize from "../../AppAuthorize";
import { RenderItemMenuProps } from "../types";

const AppItem = ({ item }: { item: RenderItemMenuProps<API.AppMenuItem> }) => {
  const { l10n } = useLocalization();
  const app = useMemo(() => {
    try {
      return App.deserialize(item.itemProps.app);
    } catch {
      return null;
    }
  }, [item.itemProps.app]);

  if (!app) {
    return null;
  }

  const translatedAppName = useMemo(() => {
    const localizedApp = translateOAuthApplication({
      uuid: app.id,
      name: app.name,
      description: app.description,
    }, l10n);

    return localizedApp.name;
  }, [app, l10n]);

  return (
    <AppAuthorize app={app} key={app.name}>
      {translatedAppName}
    </AppAuthorize>
  );
};

export default memo(AppItem);
